import { Navigate, useLocation } from "react-router-dom";
import { useMyDataQuery } from "@/generated/graphql";

interface ObjectiveRouteProps {
  children: React.ReactNode;
  for: "own_brand" | "other_channels";
}

const ObjectiveRoute = ({ children, for: requiredObjective }: ObjectiveRouteProps) => {
  const { data, loading } = useMyDataQuery();
  const location = useLocation();

  if (loading) return null;

  const objective = data?.myData?.onboarding_objective;
  if (objective && objective !== requiredObjective) {
    const redirect = objective === "other_channels" ? "/library" : "/projects";
    // Carry the query string (e.g. ?url= from the marketing site) across the
    // redirect so the destination page can still pick up the pasted link.
    return <Navigate to={`${redirect}${location.search}`} replace />;
  }

  return <>{children}</>;
};

export default ObjectiveRoute;
